module.exports = __webpack_public_path__ + "img/banner.0c659ee0.png";